
import { isProduction } from './index';

let userRoot = [
    {
      icon: "#icon-dashboard",
      index: "dashboard",
      title: {
        'zh-CN': '工作台',
        'zh-TW': '工作台',
        'en': 'Dashboard'
      },
      member: true,
      isSelect: false,
      id: "00",
    },
    {
      icon: "#icon-team",
      index: "customer",
      title: {
        'zh-CN': '客户管理',
        'zh-TW': '客戶管理',
        'en': 'Customer Management'
      },
      id: "01",
      member: true,
      isSelect: false,
      subs: [
        {
          index: "customerInput",
          title: {
            'zh-CN': '客户录入',
            'zh-TW': '客戶錄入',
            'en': 'Customer Input'
          },
          memberRoot: true,
          id: "010",
          member: true,
          isSelect: false,
        },
        {
          index: "customerManagement",
          title: {
            'zh-CN': '客户管理',
            'zh-TW': '客戶管理',
            'en': 'Customer Management'
          },
          memberRoot: true,
          id: "011",
          member: true,
          isSelect: false,
        },
        {
          index: "totalCustomer",
          title: {
            'zh-CN': '总客户池',
            'zh-TW': '總客戶池',
            'en': 'Total Customer Pool'
          },
          memberRoot: true,
          id: '012',
          member: true,
          isSelect: false,
        },
      ],
    },
    {
      icon: "#icon-bank",
      index: "3",
      title: {
        'zh-CN': '企业管理',
        'zh-TW': '企業管理',
        'en': 'Business Management'
      },
      member: true,
      id: '02',
      isSelect: false,
      subs: [
        {
          index: "corporateInformation",
          title: {
            'zh-CN': '企业信息',
            'zh-TW': '企業信息',
            'en': 'Company Information'
          },
          memberRoot: true,
          member: true,
          isSelect: false,
          id: '020'
        },
        {
          index: "enterpriseMember",
          title: {
            'zh-CN': '企业成员',
            'zh-TW': '企業成員',
            'en': 'Enterprise Members'
          },
          id: '021',
          memberRoot: true,
          member: true,
          isSelect: false,
        },
         {
          index: "performanceAssessment",
          id: '024',
          memberRoot: true,
          member: true,
          title: {
            'zh-CN': '成员考核',
            'zh-TW': '成員考核',
            'en': 'Performance Assessment'
          },
          isSelect: false,
        },
        {
          index: "advancedForm",
          title: {
            'zh-CN': '高级表单',
            'zh-TW': '高級表單',
            'en': 'Advanced Form'
          },
          memberRoot: true,
          member: true,
          isSelect: false,
          id: '022'
        },
       
        {
          index: "advertisingManagement",
          title: {
            'zh-CN': '广告图管理',
            'zh-TW': '廣告圖管理',
            'en': 'Advertising Management'
          },
          memberRoot: true,
          member: true,
          isSelect: false,
          id: '023'
        },
      ],
    },
    {
      icon: "#icon-file-text",
      index: "orderManagement",
      title: {
        'zh-CN': '订单管理',
        'zh-TW': '訂單管理',
        'en': 'Order Management'
      },
      member: true,
      memberRoot: true,
      isSelect: false,
      id: '03',
    },
    {
      icon: "#icon-shopping",
      index: "merchandiseManagement",
      title: {
        'zh-CN': '商品管理',
        'zh-TW': '商品管理',
        'en': 'Merchandise Management'
      },
      member: true,
      memberRoot: true,
      isSelect: false,
      id: '04',
      subs: [
        {
          index: "management",
          title: {
            'zh-CN': '商品管理',
            'zh-TW': '商品管理',
            'en': 'Merchandise Management'
          },
          memberRoot: true,
          member: true,
          isSelect: false,
          id: '040'
        },
        {
          index: "appointmentManagement",
          title: {
            'zh-CN': '预约管理',
            'zh-TW': '預約管理',
            'en': 'Appointment Management'
          },
          memberRoot: true,
          member: true,
          isSelect: false,
          id: '041'
        },
      ],
    },
    {
      icon: "#icon-gift",
      index: "marketingActivities",
      title: {
        'zh-CN': '营销活动',
        'zh-TW': '營銷活動',
        'en': 'Marketing Activities'
      },
      member: true,
      id: '05',
      member: true,
      isSelect: false,
      subs: [
        {
          index: "distribution",
          title: {
            'zh-CN': '分销',
            'zh-TW': '分銷',
            'en': 'Distribution'
          },
          id: '050',
          memberRoot: true,
          member: true,
          isSelect: false,
          subs: [
            {
              index: "distributionStatistics",
              title: {
                'zh-CN': '分销统计',
                'zh-TW': '分銷統計',
                'en': 'Distribution Statistics'
              },
              memberRoot: true,
              member: true,
              isSelect: false,
              id: '0500',
            },
            {
              index: "personnelApplication",
              title: {
                'zh-CN': '人员申请',
                'zh-TW': '人員申請',
                'en': 'Personnel Application'
              },
              memberRoot: true,
              member: true,
              isSelect: false,
              id: '0501',
            },
            {
              index: "distributionLevel",
              title: {
                'zh-CN': '分销等级',
                'zh-TW': '分銷等級',
                'en': 'Distribution Level'
              },
              memberRoot: true,
              member: true,
              isSelect: false,
              id: '0502',
            },
            {
              index: "distributionOrder",
              title: {
                'zh-CN': '分销订单',
                'zh-TW': '分銷訂單',
                'en': 'Distribution Order'
              },
              memberRoot: true,
              member: true,
              isSelect: false,
              id: '0503',
            },
            {
              index: "accountTransfer",
              title: {
                'zh-CN': '到账流水',
                'zh-TW': '到賬流水',
                'en': 'Account Transfer'
              },
              memberRoot: true,
              member: true,
              isSelect: false,
              id: '0504',
            },
          ],
        },
        {
          index: "joinGroup",
          title: {
            'zh-CN': '拼团',
            'zh-TW': '拼團',
            'en': 'Group Buy'
          },
          memberRoot: true,
          member: true,
          isSelect: false,
          id: '051',
          subs: [
            {
              index: "productList",
              title: {
                'zh-CN': '拼团商品列表',
                'zh-TW': '拼團商品列表',
                'en': 'Group Buy Product List'
              },
              memberRoot: true,
              member: true,
              isSelect: false,
              id: '0510',
            },
            {
              index: "listParticipants",
              title: {
                'zh-CN': '参团列表',
                'zh-TW': '參團列表',
                'en': 'Participants List'
              },
              memberRoot: true,
              member: true,
              isSelect: false,
              id: '0511',
            },
          ],
        },
        {
          index: "spike",
          title: {
            'zh-CN': '秒杀',
            'zh-TW': '秒殺',
            'en': 'Flash Sale'
          },
          memberRoot: true,
          id: '052',
          member: true,
          isSelect: false,
          subs: [
            {
              index: "spikeList",
              title: {
                'zh-CN': '秒杀商品列表',
                'zh-TW': '秒殺商品列表',
                'en': 'Flash Sale List'
              },
              memberRoot: true,
              member: true,
              isSelect: false,
              id: '0520',
            },
          ],
        },
        {
          index: "couponManagement",
          title: {
            'zh-CN': '优惠券管理',
            'zh-TW': '優惠券管理',
            'en': 'Coupon Management'
          },
          id: '053',
          memberRoot: true,
          member: true,
          isSelect: false,
          subs: [
            {
              index: "couponList",
              title: {
                'zh-CN': '优惠券列表',
                'zh-TW': '優惠券列表',
                'en': 'Coupon List'
              },
              memberRoot: true,
              member: true,
              isSelect: false,
              id: '0530',
            },
          ],
        },
      ],
    },
    {
      icon: "#icon-mobile",
      index: "TurnToIntroduce",
      title: {
        'zh-CN': '转介绍管理',
        'zh-TW': '轉介紹管理',
        'en': 'Referral Management'
      },
      id: '012',
      member: true,
      memberRoot: true,
      isSelect: false,
      subs: [
        {
          index: "partnerList",
          title: {
            'zh-CN': '合作伙伴列表',
            'zh-TW': '合作夥伴列表',
            'en': 'Partner List'
          },
          memberRoot: true,
          member: true,
          isSelect: false,
          id: '0120' 
        },
        {
          index: "rulesSetting",
          title: {
            'zh-CN': '规则设置',
            'zh-TW': '規則設置',
            'en': 'Rules Setting'
          },
          memberRoot: true,
          id: '0121',
          member: true,
          isSelect: false,
        },
        {
          index: "withdrawalList",
          title: {
            'zh-CN': '提现列表',
            'zh-TW': '提現列表',
            'en': 'Withdrawal List'
          },
          memberRoot: true,
          id: '0122',
          member: true,
          isSelect: false,
        },
      ],
    },
    {
      icon: "#icon-creditcard",
      index: "financialManagement",
      title: {
        'zh-CN': '财务管理',
        'zh-TW': '財務管理',
        'en': 'Financial Management'
      },
      member: true,
      id: '06',
      isSelect: false,
      subs: [
        {
          index: "financialStatistics",
          title: {
            'zh-CN': '财务统计',
            'zh-TW': '財務統計',
            'en': 'Financial Statistics'
          },
          id: '060',
          memberRoot: true,
          member: true,
          isSelect: false,
        },
        {
          index: "commissionManagement",
          title: {
            'zh-CN': '佣金管理',
            'zh-TW': '佣金管理',
            'en': 'Commission Management'
          },
          id: '061',
          memberRoot: true,
          member: true,
          isSelect: false,
        },
        {
          index: "accountManagement",
          title: {
            'zh-CN': '账户管理',
            'zh-TW': '賬戶管理',
            'en': 'Account Management'
          },
          root: true,
          memberRoot: true,
          member: true,
          isSelect: false,
        },
        {
          index: "creditRecordManagement",
          title: {
            'zh-CN': '信用额度记录',
            'zh-TW': '信用額度記錄',
            'en': 'Credit Record'
          },
          id: '062',
          memberRoot: true,
          member: true,
          isSelect: false,
        },
      ],
    },

    {
      icon: "#icon-solution",
      member: true,
      id: '07',
      index: "customerArticles",
      title: {
        'zh-CN': '获客文章管理',
        'zh-TW': '獲客文章管理',
        'en': 'Customer Articles Management'
      },
      memberRoot: true,
      isSelect: false,
      subs: [
        {
          index: "customerArticles",
          title: {
            'zh-CN': '获客文章',
            'zh-TW': '獲客文章',
            'en': 'Customer Articles'
          },
          memberRoot: true,
          id: '070',
          member: true,
          isSelect: false,
        },
        {
          index: "employeeData",
          title: {
            'zh-CN': '员工数据',
            'zh-TW': '員工數據',
            'en': 'Employee Data'
          },
          memberRoot: true,
          id: '071',
          member: true,
          isSelect: false,
        },
        {
          index: "visitorData",
          title: {
            'zh-CN': '访客数据',
            'zh-TW': '訪客數據',
            'en': 'Visitor Data'
          },
          memberRoot: true,
          id: '072',
          member: true,
          isSelect: false,
        },
      ],
    },
    {
      icon: "#icon-video",
      index: "videoManage",
      title: {
        'zh-CN': '短视频管理',
        'zh-TW': '短視頻管理',
        'en': 'Video Management'
      },
      id: '08',
      member: true,
      memberRoot: true,
      isSelect: false,
    },
    {
      icon: "#icon-key",
      index: "addedServices",
      title: {
        'zh-CN': '增值服务',
        'zh-TW': '增值服務',
        'en': 'Value-Added Services'
      },
      member: true,
      id: '09',
      memberRoot: true,
      isSelect: false,
      subs: [
        {
          index: "myNeeds",
          title: {
            'zh-CN': '我的需求',
            'zh-TW': '我的需求',
            'en': 'My Needs'
          },
          memberRoot: true,
          member: true,
          isSelect: false,
        },
        {
          index: "demandCheck",
          title: {
            'zh-CN': '需求审核',
            'zh-TW': '需求審核',
            'en': 'Demand Check'
          },
          root: true,
          administrator: false,
          memberRoot: true,
          id: '090',
          member: true,
          isSelect: false,
        },
        {
          index: "demandContactsCheck",
          title: {
            'zh-CN': '人脉集市审核',
            'zh-TW': '人脈集市審核',
            'en': 'Contacts Check'
          },
          root: true,
          administrator: false,
          memberRoot: true,
          id: '092',
          member: true,
          isSelect: false,
        },
        {
          index: "demandProtuctsCheck",
          title: {
            'zh-CN': '产品中心审核',
            'zh-TW': '產品中心審核',
            'en': 'Products Check'
          },
          root: true,
          administrator: false,
          memberRoot: true,
          id: '091',
          member: true,
          isSelect: false,
        },
        {
          index: "demandPublishSetting",
          title: {
            'zh-CN': '发布设置',
            'zh-TW': '發布設置',
            'en': 'Publish Setting'
          },
          memberRoot: true,
          administrator: false,
          root: true,
          id: '093',
          member: true,
          isSelect: false,
        },
        {
          index: "demandReport",
          title: {
            'zh-CN': '举报处理',
            'zh-TW': '舉報處理',
            'en': 'Report Handling'
          },
          memberRoot: true,
          administrator: false,
          root: true,
          id: '090',
          member: true,
          isSelect: false,
        },
        {
          index: "demandCustomize",
          title: {
            'zh-CN': '自定义设置',
            'zh-TW': '自定義設置',
            'en': 'Customize Setting'
          },
          memberRoot: true,
          administrator: false,
          root: true,
          id: '094',
          member: true,
          isSelect: false,
        },

      ],
    },
    {
      icon: '#icon-share',
      index: "sharingPromotion",
      title: {
        'zh-CN': '分享推广管理',
        'zh-TW': '分享推廣管理',
        'en': 'Sharing Promotion Management'
      },
      id: '100',
      member: true,
      memberRoot: true,
      isSelect: false,
      subs: [
        {
          index: "posterAtlas",
          title: {
            'zh-CN': '海报图集',
            'zh-TW': '海報圖集',
            'en': 'Poster Atlas'
          },
          memberRoot: true,
          administrator: false,
          root: true,
          member: true,
          isSelect: false,
          id: '1000',
        },
        {
          index: "clockData",
          title: {
            'zh-CN': '打卡数据',
            'zh-TW': '打卡數據',
            'en': 'Clock Data'
          },
          memberRoot: true,
          member: true,
          isSelect: false,
          id: '1001',
        },
      ],
    },
    {
      icon: "#icon-api",
      index: "miniProgram",
      title: {
        'zh-CN': '前端设置',
        'zh-TW': '前端設置',
        'en': 'Mini Program Settings'
      },
      id: '110',
      memberRoot: true,
      isSelect: false,
      member: true,
      subs: [
        {
          index: "appletConfig",
          title: {
            'zh-CN': '基础设置',
            'zh-TW': '基礎設置',
            'en': 'Basic Settings'
          },
          memberRoot: true,
          id: '1100',
          member: true,
          isSelect: false,
        },
        {
          index: "basicSetting",
          title: {
            'zh-CN': '小程序配置',
            'zh-TW': '小程序配置',
            'en': 'Mini Program Configuration'
          },
          root: true,
          memberRoot: true,
          member: true,
          isSelect: false,
          id: '1101',
        },
        {
          index: "mallSetting",
          title: {
            'zh-CN': '商城设置',
            'zh-TW': '商城設置',
            'en': 'Mall Settings'
          },
          memberRoot: true,
          id: '1102',
          member: true,
          isSelect: false,
        },
      ],
    },
    {
        icon: "#icon-cluster",
        index: "agentManage",
        title: {
          'zh-CN': '代理企业',
          'zh-TW': '代理企業',
          'en': 'Agent Enterprise'
        },
        id: '1200',
        member: true,
        memberRoot: true,
        isSelect: false,
        isAgent: true,
    },
  
  ]

let defaultRouters = ['022', '04', '040', '062', '08']

let userInfo = JSON.parse(localStorage.getItem("info"));
if (userInfo && !userInfo.main) {
  userRoot.forEach((item, index) => {
    if (item.id == "09") {
      userRoot.splice(index, 1);
    }
  });
}

// 正式环境过滤规则
function applyProductionFilters(menuItems) {
  if (!isProduction()) {
    return menuItems;
  }
  
  return menuItems.filter(item => {
    // 隐藏获客文章管理 (id: '07')
    if (item.id === '07') {
      return false;
    }
    
    // 隐藏增值服务 (id: '09')
    if (item.id === '09') {
      return false;
    }

    // 隐藏转介绍
    if(item.id === '012'){
      return false;
    }

    // 隐藏分享
    if(item.id === '100'){
      return false;
    }

    // 隐藏前端设置
    if(item.id === '110'){
      return false;
    }
    
    
    // 处理子菜单的过滤
    if (item.subs) {

      // 过滤营销活动中的分销 (id: '050')、拼团 (id: '051')、秒杀 (id: '052')
      if (item.id === '05') { // 营销活动
        item.subs = item.subs.filter(subItem => {
          return subItem.id !== '050' && subItem.id !== '051' && subItem.id !== '052';
        });
        // 如果过滤后没有子菜单，则隐藏整个菜单
        if (item.subs.length === 0) {
          return false;
        }
      }

      if(item.id === '04'){
        item.subs = item.subs.filter(subItem => {
          return subItem.id !== '041';
        });
        // 如果过滤后没有子菜单，则隐藏整个菜单
        if (item.subs.length === 0) {
          return false;
        }
      }

      // 过滤财务管理中的佣金管理 (id: '061')
      if(item.id === '06'){
        item.subs = item.subs.filter(subItem => {
          return subItem.id !== '061';
        });
        // 如果过滤后没有子菜单，则隐藏整个菜单
        if (item.subs.length === 0) {
          return false;
        }
      }
    }
    
    return true;
  });
}

// 应用正式环境过滤规则
userRoot = applyProductionFilters(userRoot);

// 获取当前语言的标签文本
export function getLabelText(labelObj, currentLanguage = 'zh-TW') {
  if (typeof labelObj === 'string') {
    return labelObj;
  }
  if (typeof labelObj === 'object' && labelObj !== null) {
    return labelObj[currentLanguage] || labelObj['zh-TW'] || '';
  }
  return '';
}

// 递归处理权限数据，添加多语言支持
export function processI18nPermissions(permissions, currentLanguage = 'zh-TW') {
  if (!Array.isArray(permissions)) {
    return permissions;
  }
  
  return permissions.map(item => {
    const newItem = { ...item };
    
    // 处理标签
    if (item.title) {
      newItem.title = getLabelText(item.title, currentLanguage);
    }
    
    // 递归处理子项
    if (item.subs && Array.isArray(item.subs)) {
      newItem.subs = processI18nPermissions(item.subs, currentLanguage);
    }
    
    return newItem;
  });
}

export default {
  userRoot,
  defaultRouters
};
